export default {
  NEW: "new",
  OPEN: "open",
  SENT: "sent",
  PAID: "paid",
  WAIT: "wait",
  FAILED: "failed",
  isOpen: function(invoiceStatus) {
    if (
      invoiceStatus == this.OPEN ||
      invoiceStatus == this.SENT ||
      invoiceStatus == this.WAIT
    ) {
      return true;
    }
    return false;
  }
};
